<div class="height-fit">
  <div *ngIf="!!showText" class="height-fit">

    <span class="text-ellipsis">{{text}}</span>

    <bringoz-button *ngIf="isShowCopyBtn"
                    type="tertiary" size="fit"
                    (onClick)="copyToClipboard($event)">
      <bringoz-icon iconName="copy"></bringoz-icon>
    </bringoz-button>

  </div>

  <bringoz-button *ngIf="(!showText && isShowCopyBtn) || (!showText && isShowAlways)"
                  type="tertiary" size="fit"
                  (onClick)="copyToClipboard($event)">
    <bringoz-icon iconName="copy"></bringoz-icon>
  </bringoz-button>

</div>
